import axios from "axios";
import config from "../config";

export const getRecords = ({
    page,
    order,
    startDate,
    endDate,
}: {
    page: number
    order: string
    startDate: string
    endDate: string
}) => axios.get(`${config.API_URL}/records?page=${page}&startDate=${startDate}&endDate=${endDate}&order=${order}`)